import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'
import { SidebarProvider } from './components/contexts/SidebarContext.jsx'


createRoot(document.getElementById('root')).render(
  <SidebarProvider>
    <App />
  </SidebarProvider>,
)
